import React from "react";
import styled from "styled-components";
import GeneralTable from "./customField/generalTable";

const ViolationFieldValue = styled.div`
  color: #fa0000;
`;

const URL_RE = /^https?:\/\//i;
const JSON_RE = /^\s*[\[{]/;

const isParseableJson = data => {
  if (!JSON_RE.test(data)) return false;
  try { JSON.parse(data); return true; } catch (e) { return false; }
};

const renderInferredValue = item => {
  const data = item.data;
  if (typeof data !== 'string' || data.length === 0) return data;
  if (URL_RE.test(data)) {
    return <a target="_blank" href={data}>{data}</a>;
  }
  if (isParseableJson(data)) {
    return <GeneralTable item={item} />;
  }
  return data.charAt(0).toUpperCase() + data.slice(1);
};

function ViolationRuleTextFieldValue({ item }) {
  const value = renderInferredValue(item);
  if (item.violation?.length > 0) {
    return <ViolationFieldValue>{value}</ViolationFieldValue>;
  }
  return <>{value}</>;
}

export default ViolationRuleTextFieldValue;
